import { gql } from "@apollo/client";

export const QUERYlockerOccupancyAvgOccupancyRate = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $lockerTypeId: ID
    $lockers: [ID]
  ) {
    lockerOccupancyAvgOccupancyRateByLocker(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerTypeId: $lockerTypeId
      lockers: $lockers
    ) {
      lockerId
      lockerName
      lockerStatus
      doorSizes {
        size
        doors
        packages
        avgOccupiedDoors
        avgTurnoverRate
        avgOccupancyRate
      }
    }
  }
`;

export const QUERYlockerOccupancyReportSummary = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $lockerTypeId: ID
    $lockers: [ID]
  ) {
    lockerOccupancyReportSummary(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerTypeId: $lockerTypeId
      lockers: $lockers
    ) {
      doors
      lockers
      packages
      doorSizes {
        size
        totalDoors
        utilizationRate
        doors
        lockers
        packages
        dimension
      }
    }
  }
`;

export const QUERYlockerOccupancyTable1 = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $lockerTypeId: ID
    $lockers: [ID]
    $period: String
  ) {
    lockerOccupancyByDate(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerTypeId: $lockerTypeId
      lockers: $lockers
      period: $period
    ) {
      doors
      lockers
      packages
      avgOccupancyRate
      date
    }
  }
`;

export const QUERYlockerOccupancyTable2 = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $lockerTypeId: ID
    $lockers: [ID]
    $period: String
  ) {
    lockerOccupancyDoorSizeOccupancyByDate(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerTypeId: $lockerTypeId
      lockers: $lockers
      period: $period
    ) {
      doorSizes {
        doorSizeId
        size
        doors
        lockers
        packages
        avgOccupancyRate
      }
      date
    }
  }
`;
